import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { SpaceColor } from '~/common/define/color'
import NavigationMenuItem, { NavigationMenuItemVar } from '~/components/molecules/navigation/menu/NavigationMenuItem'
import { SingleMenuMode } from '~/common/define/menu'
import Sortable from '~/components/utils/sort/Sortable'

interface Props {
  items: NavigationMenuItemVar[]
  mode: SingleMenuMode
  color: SpaceColor
  onListUpdated(items: NavigationMenuItemVar[]): void
}

const NavigationMenuList = ({items, mode, color, onListUpdated}: Props) => {
  return (
    <ul className={styles.menu__list}>
      <Sortable items={items} onDragEnd={onListUpdated} disabled={mode != SingleMenuMode.SORT}>
        {items.map((item) =>
          <NavigationMenuItem key={item.id} item={item} mode={mode} color={color}/>
        )}
      </Sortable>
    </ul>
  )
}

export default NavigationMenuList